import { Router } from 'express';
import { DocService } from '../services/doc-service.js';
import { ApiError } from '../types.js';

export const documentsRouter = Router();
const docService = new DocService();

// 获取所有文档
documentsRouter.get('/', async (req, res, next) => {
  try {
    const docs = await docService.list();
    res.success(docs);
  } catch (error) {
    next(error);
  }
});

// 获取单个文档
documentsRouter.get('/:id', async (req, res, next) => {
  try {
    const doc = await docService.get(req.params.id);
    if (!doc) {
      throw new ApiError(404, 'Document not found');
    }
    res.success(doc);
  } catch (error) {
    next(error);
  }
});

// 获取文档内容
documentsRouter.get('/:id/content', async (req, res, next) => {
  try {
    const content = await docService.getContent(req.params.id);
    if (content === null) {
      throw new ApiError(404, 'Document not found');
    }
    res.success({ content });
  } catch (error) {
    next(error);
  }
});